// TODO: Fix ts-nocheck SDOH3 for QuestionBody
// @ts-nocheck
import { useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

import { Homeless, TouchpointQuestions } from 'types';

import CardBackground from 'components/_shared/CardBackground';
import LoadingCircle from 'components/_shared/LoadingCircle';
import QuestionBody from './components/QuestionBody';
import AgreementScaleQuestion from './components/AgreementScaleQuestion.jsx';
import FreeResponseQuestion from './components/FreeResponseQuestion.jsx';
import * as api from '../../../../api/touchpointQuestions';

import Button from '@mui/material/Button';
import { createStyles, makeStyles } from '@mui/styles';
import SDOHError from '../../../_archived/holder_profile/SDOH/components/SDOHError.jsx';

const useStyles = makeStyles(() =>
    createStyles({
        statusContainer: {
            position: 'relative',
            borderRadius: '16px',
            height: 'fit-content',
            margin: '0 auto 50px auto',
            padding: '50px 0 0 0',
            width: '80%'
        },
        buttonContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '40px 40px 20px 40px'
        },
        nextBtn: {
            background: 'linear-gradient(180deg, #8571DF 0%, #7378E8 100%)',
            borderRadius: '28px',
            boxShadow: '0px 8px 16px 4px rgba(0, 0, 0, 0.08)',
            color: '#FBFBFF',
            fontSize: '24px',
            fontWeight: 700,
            padding: '15px 140px',
            textTransform: 'none',
            '&:hover': {
                background: 'linear-gradient(180deg, #8571DF 0%, #918ED7 100%)'
            },
            '& i': {
                marginLeft: '15px'
            }
        },
        disabled: {
            background: '#E3E3FA',
            color: '#ffffff !important'
        },
        success: {
            background: 'linear-gradient(180deg, #42dd9e 0%, #7fe8bd 100%)',
            color: '#ffffff !important'
        }
    })
);

type StatusCaptureProps = {
    catchUpItemID?: number;
    customClasses?: {
        [key: string]: {
            [key: string]: string;
        };
    };
    getTouchpointAnswersRequest: (
        id: number,
        ids: number[],
        qols: number[]
    ) => void;
    homelessInfo: Homeless;
    isSubmittingStatusCapture: boolean;
    setSdohStatus: (status: boolean) => void;
    submitStatusCapture: (id: number, answers: any) => void;
    touchpointQuestions: TouchpointQuestions[];
    touchpointQuestionIds: number[];
    touchpointQuestionQOLs: number[];
    updateGoalActionStatus: (
        id: number,
        status: 'cancelled' | 'completed'
    ) => void;
};

const StatusCapture: React.FC<StatusCaptureProps> = ({
    catchUpItemID,
    customClasses,
    getTouchpointAnswersRequest,
    homelessInfo,
    isSubmittingStatusCapture,
    setSdohStatus,
    submitStatusCapture,
    touchpointQuestions,
    touchpointQuestionIds,
    touchpointQuestionQOLs,
    updateGoalActionStatus
}) => {
    const classes = useStyles();
    const history = useHistory();
    const match = useRouteMatch();

    const [memberFormQuestions, setMemberFormQuestions] = useState<any[]>([]);   
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(""); 
    const [answers, setAnswers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [usingMemberForm, setUsingMemberForm] = useState(false);

    const fromState = history.location.state as {
        from?: string;
        member_form_id?: number;
        id?: number;
    };

    useEffect(() => {
        if (fromState?.from === "profileQOLAssessment" && fromState?.member_form_id) {
            setUsingMemberForm(true);
        }
    }, [fromState]);

    useEffect(() => {
        if (usingMemberForm && fromState?.member_form_id && homelessInfo?.id) {
          api.fetchMemberFormQuestions(fromState.member_form_id, homelessInfo.id)
            .then(async (res) => {
                if (!res.ok) {
                    const errorBody = await res.json().catch(() => ({}));
                    throw new Error(errorBody.message || `Request failed with status ${res.status}`);
                }
                const raw = await res.json();

                setMemberFormQuestions(raw.member_form?.touchpoint_questions);
            })
            .catch((err) => {
                console.error(err);
                setError(true);
                setErrorMessage("Failed to load the questions for this form.");
            });
        }
      }, [usingMemberForm, fromState?.member_form_id, homelessInfo?.id]);
      
      
    const questions = usingMemberForm
        ? memberFormQuestions
        : touchpointQuestions?.filter((q) => q.type === "StatusQuestion");

    const formatAnswers = (
        answers: {
            answer: string[];
            quality_of_life_measure_id: number;
        }[]
    ) => {
        return answers.map((a) => {

            let answer = a.answer;
            if (Array.isArray(a.answer)) {
                answer = a.answer.length > 1
                                    ? a.answer.join(', ')
                                    : a.answer[0]
            }
            return {
                ...a,
                answer,
                quality_of_life_measure_id: answer.quality_of_life_measure_id
            }
        });
    };

    const backFunction = () => {
        const newUrl = match.url.replace(/\/qol/, '');
        history.push(newUrl);
    }
    
    const retryFunction = () => {
        history.push(match.url, { from: 'retry' });
    }

    const shouldShowPublicFacingMessage = (question) => {
        if (question.type === "SupplementalQuestion" || question.answers_create_life_updates) return true;
        return false;
    }

    const handleSubmit = async () => {
        const formattedAnswers = formatAnswers(answers);
        const id = homelessInfo?.id;
        const newUrl = match.url.replace(/\/qol/, '');

        setLoading(true);
        
        try {
            const result = await submitStatusCapture(id, formattedAnswers, catchUpItemID, fromState?.member_form_id);
        
            // this makes it refresh, which is something that needs to be changed soon
            if (!catchUpItemID) {
                setSubmitted(true);
    
                setTimeout(() => {
                    getTouchpointAnswersRequest(
                        id,
                        touchpointQuestionIds,
                        touchpointQuestionQOLs
                    );
    
                    const fromState = {};
    
                    if (!history.location.state) {
                        fromState.from = 'updateStatusComplete';
                    } else if (usingMemberForm) {
                        fromState.from = 'exitedMemberForm';
                        fromState.completedGoalAction = result.completedGoalAction
                        fromState.completedGoalActionAmount = result.completedGoalActionAmount
                    } else {
                        // TODO: Fix type for fromState
                        if (history.location.state.from === 'exitQol') {
                            fromState.from = 'exitedProfileQOLAssessment';
                            fromState.completedGoalAction = result.completedGoalAction
                            fromState.completedGoalActionAmount = result.completedGoalActionAmount
                        } else if (history.location.state.from === 'exitQol') {
                            fromState.from = 'exitedQol';
                        }
    
                        setSdohStatus(true);
                    }
    
                    history.push(newUrl, fromState);
    
                }, 1500);
            }
        } catch (error) {
            console.error("Submit failed:", error);
        }   
    };

    const renderDisabledClass = () => {
        const allQuestionsAnswered =
            Array.isArray(questions) &&
            questions.length > 0 &&
            questions.every((question) =>
                answers?.some(
                    (ans) => 
                        ans.touchpoint_question_id === question.id &&
                        ans.answer !== undefined &&
                        ans.answer !== null &&
                        ans.answer !== ""
                )
            );
            
        const isDisabled = !allQuestionsAnswered || loading || submitted;
        const isSuccess = submitted && !loading;

        return isSuccess
            ? `${classes.nextBtn} ${classes.success}`
            : isDisabled
            ? `${classes.nextBtn} ${classes.disabled}`
            : classes.nextBtn;
    };

    const renderLoading = () => {
        if (!loading && !submitted) {
            return usingMemberForm ? "Submit" : "Save Statuses";
        }
        
        if (!loading && submitted) {
            return usingMemberForm ? "Submitted 🎉" : "Status Captured 🎉";
        }

        return <LoadingCircle />;
    };

    useEffect(() => {
        if (isSubmittingStatusCapture) {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [isSubmittingStatusCapture]);

    if (error) {
        return (
            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <SDOHError
                    errorMessage={errorMessage}
                    backFunction={backFunction}
                    retryFunction={retryFunction}
                />
            </div>
        )
    }

    return (
        <div
            className={classes.statusContainer}
            style={
                customClasses?.statusContainer
                    ? customClasses.statusContainer
                    : {}
            }
        >
            <CardBackground customClasses={customClasses} />
            {questions.map((question, index) => {
                const commonProps = {
                    setAnswers,
                    questions: question,
                    questionNum: index,
                    questionLength: questions.length,
                    name: homelessInfo.name,
                    answers,
                    showPublicFacingMessage: shouldShowPublicFacingMessage(question)
                };

                switch (question.type) {
                    case "StatusQuestion":
                      return <QuestionBody {...commonProps} />;
                
                    case "AgreementScaleQuestion":
                      return <AgreementScaleQuestion {...commonProps} />;
                
                    case "FreeResponseQuestion":
                      return <FreeResponseQuestion {...commonProps} />;
                    case "SupplementalQuestion":
                      return <FreeResponseQuestion {...commonProps} />;
                    default:
                      return null;
                }
            })}

            <div className={classes.buttonContainer}>
                <Button
                    className={renderDisabledClass()}
                    disabled={
                        (answers && !answers.length) || loading || submitted
                    }
                    onClick={() => handleSubmit()}
                >
                    {renderLoading()}
                </Button>
            </div>
        </div>
    );
};

export default StatusCapture;
